import { BaseService } from './baseService';
import { RecordCategoryDto, RecordCategoryFormData } from '../types/recordCategory'; // Βεβαιώσου ότι το αρχείο ονομάζεται έτσι στον φάκελο types

class RecordCategoryService extends BaseService<RecordCategoryDto, RecordCategoryFormData> {
    constructor() {
        super('/RecordCategory');
    }
}

export const recordCategoryService = new RecordCategoryService();